var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var SftpExportSettings_1;
import '@symon-ai/wisepipe-common'; // force import for JsonSchema
import { JSON, JsonDiscriminatorValue, JsonSchema, OnDeserialized } from '@symon-ai/wisepipe-serialize';
import { ExportSettings, ExportSupportedFileType, ExportType } from './exportSettings';
const SftpExportSettingsSchema = {
    $id: 'urn:wisepipe-common-export:SftpExportSettings',
    type: 'object',
    properties: {
        sftpPrefix: { type: 'string' },
        publicKey: { type: 'string', minLength: 1 },
        s3StagingLoc: { $ref: 'urn:wisepipe-common:S3File' },
        isExcel: { type: 'boolean' },
        addTimestampSuffix: { type: 'boolean' },
        delimiter: { type: 'string' },
        exportFileType: { type: 'string', enum: Object.values(ExportSupportedFileType) }
    },
    required: ['sftpPrefix']
};
let SftpExportSettings = SftpExportSettings_1 = class SftpExportSettings extends ExportSettings {
    constructor(sftpPrefix, publicKey, s3StagingLoc, addTimestampSuffix, delimiter, exportFileType) {
        super(ExportType.Sftp);
        this.sftpPrefix = sftpPrefix;
        if (publicKey !== undefined)
            this.publicKey = publicKey;
        if (s3StagingLoc !== undefined)
            this.s3StagingLoc = s3StagingLoc;
        if (delimiter !== undefined)
            this.delimiter = delimiter;
        if (exportFileType !== undefined)
            this.exportFileType = exportFileType;
        this.addTimestampSuffix = addTimestampSuffix ?? false;
        JSON.validate(this, SftpExportSettings_1);
    }
    get isExcelExport() {
        return this.exportFileType === ExportSupportedFileType.Excel;
    }
    onDeserialized() {
        if (this.isExcel) {
            this.exportFileType = ExportSupportedFileType.Excel;
        }
        if (!this.exportFileType) {
            this.exportFileType = ExportSupportedFileType.Csv;
        }
    }
};
__decorate([
    OnDeserialized()
], SftpExportSettings.prototype, "onDeserialized", null);
SftpExportSettings = SftpExportSettings_1 = __decorate([
    JsonSchema(SftpExportSettingsSchema),
    JsonDiscriminatorValue(ExportType.Sftp)
], SftpExportSettings);
export { SftpExportSettings };
//# sourceMappingURL=sftpExportSettings.js.map